import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { GridStoreSearch } from 'src/app/modules/data-customization/store-management/actions/search.actions';
import { DeselectedRowData } from '../actions/grid.actions';
import { ItemsPerPageChanged, OrderingChanged, PagingChanged, SortingChanged } from '../actions/paginator.actions';
import { EliquaFacadeService } from '../services/eliqua.facade.service';

@Injectable()
export class PaginatorEffects {
  constructor(
    private actions$: Actions,
    private eliquaFacadeService: EliquaFacadeService,
  ) {}

  newItemSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItemsPerPageChanged),
      filter(() => this.eliquaFacadeService.activeComponent !== 'StoreSearchComponent'),
      switchMap(() => this.eliquaFacadeService.serviceSelect()),
    ),
  );

  sortingSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SortingChanged),
      filter(() => this.eliquaFacadeService.activeComponent !== 'StoreSearchComponent'),
      switchMap(() => this.eliquaFacadeService.serviceSelect()),
    ),
  );

  reorderSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderingChanged),
      filter(() => this.eliquaFacadeService.activeComponent !== 'StoreSearchComponent'),
      switchMap(() => this.eliquaFacadeService.serviceSelect()),
    ),
  );

  pagingChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PagingChanged),
      filter(() => this.eliquaFacadeService.activeComponent !== 'StoreSearchComponent'),
      switchMap(() => this.eliquaFacadeService.serviceSelect()),
    ),
  );

  storePagingChanged$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItemsPerPageChanged, SortingChanged, OrderingChanged, PagingChanged),
      filter(() => this.eliquaFacadeService.activeComponent === 'StoreSearchComponent'),
      switchMap(() => of(GridStoreSearch())),
    ),
  );

  paginatorSearchDeselectRow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PagingChanged),
      map(() => DeselectedRowData()),
    ),
  );
}
